import {createCargoCorpRepository} from '@yandex-delivery/api/repo/cargo-corp/external'
import {CargoCrmRepository} from '@yandex-delivery/api/repo/cargo-crm'
import {createDcaaRepository} from '@yandex-delivery/api/repo/dcaa/external'
import {createDraftRepository} from '@yandex-delivery/api/repo/draft'
import {createPassportRepository} from '@yandex-delivery/api/repo/passport'
import {createGeoService} from '@yandex-delivery/api/service/geo'
import {createOrderService} from '@yandex-delivery/api/service/order'
import {createPaymentCardService} from '@yandex-delivery/api/service/payment'
import {createRegistrationService} from '@yandex-delivery/api/service/registration'

import {fetch, passportFetch} from './fetch'

export {fetchAddressSuggest} from './deprecated/fetch-address-suggest'
export type {SuggestValue} from './deprecated/fetch-address-suggest-utils'
export {fetchClosestOfferDeprecated} from './deprecated/fetch-closest-offer'
export {fetchConfirmOfferDeprecated} from './deprecated/fetch-confirm-offer'
export {fetchCreateAccepted} from './deprecated/fetch-create-accepted'
export {fetchDetectLocationDeprecated} from './deprecated/fetch-detect-location'
export {
  type LocationRequest,
  type LocationResponse,
  fetchDetectLocationByCity,
} from './deprecated/fetch-detect-location-by-city'
export {fetchLastOrderId} from './deprecated/fetch-last-order-id'
export {fetchNddDeliveryIntervalsDeprecated} from './deprecated/fetch-ndd-delivery-intervals'
export {fetchOffersCalculate} from './deprecated/fetch-offers-calculate'
export {fetchOffersInfoDeprecated} from './deprecated/fetch-offers-info'
export {fetchPickUpDropOffPoints} from './deprecated/fetch-pick-up-drop-off-points'
export {fetchRemoveLastOrderId} from './deprecated/fetch-remove-last-order-id'
export {fetchMemoizedPollSharing, fetchPollSharing} from './deprecated/fetch-sharing'
export {fetchStoreLastOrderId} from './deprecated/fetch-store-last-order-id'
export {fetchVerticals as fetchVerticalsDeprecated} from './deprecated/fetch-verticals'
export {fetch}

export {fetchInitialRoute} from './services/fetch-initial-route'

const passportRepository = createPassportRepository({
  fetch: passportFetch,
})
const cargoCorpRepository = createCargoCorpRepository({
  fetch: fetch,
})
const dcaaRepository = createDcaaRepository(/* тут можно внедрить логгер и прочие зависимости */)
const draftRepository = createDraftRepository({
  key: '__ya_delivery_order_form_state_v1__',
})

export const {fetchCards, fetchBindingUrl, fetchBoundedCard} = createPaymentCardService(cargoCorpRepository)
export const {fetchRegistration, fetchCardBound} = createRegistrationService({
  corpRepository: cargoCorpRepository,
  crmRepository: CargoCrmRepository,
  passportRepository,
})
export const {fetchGpsZone} = createGeoService()
export const {fetchPaymentInfo, fetchVerticals, fetchPersistDraftSync, fetchRestoreDraftSync, fetchClearDraftSync} =
  createOrderService({
    dcaaRepository,
    draftRepository,
  })
export const fetchAllAccountsDeprecated = passportRepository.fetchAllAccounts
